module.exports = __webpack_public_path__ + "img/end-bg-2.ad0e38be.svg";